/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortCallsGet200ResponseRecordsInner } from './PortCallsGet200ResponseRecordsInner';
import {
    PortCallsGet200ResponseRecordsInnerFromJSON,
    PortCallsGet200ResponseRecordsInnerFromJSONTyped,
    PortCallsGet200ResponseRecordsInnerToJSON,
} from './PortCallsGet200ResponseRecordsInner';

/**
 * 
 * @export
 * @interface PortCallsGet200Response
 */
export interface PortCallsGet200Response {
    /**
     * List of port calls. The information contains the port locode and the ship/vessel information and ATA and ATD (if the vessel has left)
     * @type {Array<PortCallsGet200ResponseRecordsInner>}
     * @memberof PortCallsGet200Response
     */
    records?: Array<PortCallsGet200ResponseRecordsInner>;
}

/**
 * Check if a given object implements the PortCallsGet200Response interface.
 */
export function instanceOfPortCallsGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortCallsGet200ResponseFromJSON(json: any): PortCallsGet200Response {
    return PortCallsGet200ResponseFromJSONTyped(json, false);
}

export function PortCallsGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortCallsGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(PortCallsGet200ResponseRecordsInnerFromJSON)),
    };
}

export function PortCallsGet200ResponseToJSON(value?: PortCallsGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(PortCallsGet200ResponseRecordsInnerToJSON)),
    };
}

